// src/App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import ClientsPage from "./pages/ClientsPage";
import Analytics from "./components/Analytics";
import Login from "./components/Login";
import "./App.css";

function App() {
  const [loggedIn, setLoggedIn] = useState(
    JSON.parse(localStorage.getItem("loggedIn")) || false
  );
  useEffect(() => {
    localStorage.setItem("loggedIn", JSON.stringify(loggedIn));
  }, [loggedIn]);
  const handleLoginSuccess = () => setLoggedIn(true);
  const handleLogout = () => setLoggedIn(false);

  if (!loggedIn) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  return (
    <Router>
      <div className="min-h-screen bg-gray-100">
        <Navbar onLogout={handleLogout} />
        <div className=" mx-auto">
          <Routes>
            <Route path="/" element={<Navigate to="/clientes" replace />} />
            <Route path="/clientes" element={<ClientsPage />} />
            <Route path="/analiticas" element={<Analytics />} />
            {/* Puedes agregar más rutas aquí */}
            <Route path="*" element={<Navigate to="/clientes" replace />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
